<template>
  <div class="indexswiperbtnbox container" v-if="description||title||(button&&button.url&&button.text)" :class="slide_height" :style="{textAlign:align}">
    <p v-if="description" class="secondary_title" :style="{color:text_color}">{{description}}</p>
    <h2 v-if="title" class="title_font" :style="{fontSize:fontsize,fontFamily:title_font_family,color:text_color}">{{title}}</h2>
    <a v-if="button&&button.url&&button.text" :href="button.url.url||button.url" class="shopnow text_font" :class="slide_height=='adaptfirst'?'main_button':''" :style="{backgroundColor:button_background_color,color:button_text_color}">{{button.text}}</a>
  </div>
</template>
<script>
export default {
  props: [
    "title",
    "description",
    "button",
    "align",
    "title_font_size",
    "title_font_family",
    "button_background_color",
    "button_text_color",
    "text_color",
    "slide_height"
  ],
  data() {
    return {
      fontsize: 20
    };
  },
  beforeMount() {
    console.log('this.text_color',this.text_color);
    // var numArr = this.title_font_size.match(/\d+/g);
    this.fontsize = parseInt(this.title_font_size) + 20 + "px";
  },
  mounted() {}
};
</script>
<style scoped lang='scss'>
.indexswiperbtnbox {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  p {
    -webkit-text-size-adjust: auto;
    box-sizing: border-box;
    color: white;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 1.8px;
    line-height: 28.13px;
    margin-bottom: 15.04px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    word-break: break-word;
  }
  h2 {
    width: 100%;
    font-size: 64px;
    margin-bottom: 0;
    padding-bottom: 20px;
    color: white;
    word-break: break-word;
  }
  .shopnow {
    display: inline-block;
    text-decoration: none;
    padding: 12px 20px;
    background: white;
    color: black;
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    font-style: normal;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 12px 20px;
    font-size: 0.86667em;
  }
}
@media screen and( max-width: 764px) {
  .indexswiperbtnbox {
    h2 {
      font-size: 60px;
    }
  }
}
@media screen and( max-width: 591px) {
  .indexswiperbtnbox {
    h2 {
      font-size: 50px;
    }
    h4 {
      font-size: 15px;
    }
  }
}
.adaptfirst{
  position: relative;
  top: unset;
  left: unset;
  transform: unset;
  padding-top:24px;
  padding-bottom:16px;
}
</style>